import React from 'react';
import { Box, Grid, Card, CardContent, Typography } from '@mui/material';
import { sanitizeHTML } from '../Utils/formattingUtils';
import { CustomCard } from './CustomCard';

const events = [
  {
    title: 'First Run',
    content: `<p>Our first official social gathering of the season, First Run is a chance to see old friends, meet new friends, and raise money for our club through an awesome raffle.</p>`,
  },
  {
    title: 'Last Run',
    content: `<p>Our last official event of the year is our Last Run Dinner. It doesn\'t matter if we go to a restaurant, take a Barnegate Bay cruise, or picnic at a Blue Claws game, because we know that we\'ll always have a great time with our ski club friends.</p>`,
  },
  {
    title: 'Work Weekends',
    content: `<p>Several times a year members descend upon the lodge armed with tools, cleaning products, lots of energy and a spirit of fun. We work hard all day cleaning and fixing and making our home away from home look beautiful.</p>

    <p>The cost of work weekend is $20 per person to cover the cost of food. There is no charge to stay at the lodge during work weekends.</p>
    
    <p>Members who participate earn a free stay at the lodge which can be used during the season, and they also receive a "get out of a job" card.</p>
    
    <p>Work weekends are normally scheduled in the spring and fall.</p>`,
  },
  // add the rest of the events here...
];

const EventsGrid = () => {
  return (
    <Box sx={{ flexGrow: 1, mt: 3 }}>
      <CustomCard posts={events} />
    </Box>
  );
};

export default EventsGrid;
